import React, { useState } from "react";
import { getIconForUID } from "components/FormerEditor/utils";
import Modal from "components/Modal";
import ModalContent from "components/ModalContent";
import { cellGrow } from "constants/styles";
import LiteYouTubeEmbed from "react-lite-youtube-embed";
import { COLORS } from "utils/styles";
import { styles } from "./styles";

const PRESENTATION = {
  MODAL: "modal",
  INLINE: "inline"
};

const VideoPreview = ({
  header,
  body,
  videoId,
  presentation = PRESENTATION.MODAL
}) => {
  const PlayIcon = getIconForUID("play");
  const [showModal, setShowModal] = useState(false);

  const videoPreview = (
    <LiteYouTubeEmbed
      id={videoId}
      //   adNetwork={true} // Default true, to preconnect or not to doubleclick addresses called by YouTube iframe (the adnetwork from Google)
      params="" // any params you want to pass to the URL, assume we already had '&' and pass your parameters string
      playlist={false} // Use  true when your ID be from a playlist
      poster="hqdefault" // Defines the image size to call on first render as poster image. Possible values are "default","mqdefault",  "hqdefault", "sddefault" and "maxresdefault". Default value for this prop is "hqdefault". Please be aware that "sddefault" and "maxresdefault", high resolution images are not always avaialble for every video. See: https://stackoverflow.com/questions/2068344/how-do-i-get-a-youtube-video-thumbnail-from-the-youtube-api
      title="YouTube Embed" // a11y, always provide a title for iFrames: https://dequeuniversity.com/tips/provide-iframe-titles Help the web be accessible ;)
      noCookie={true} //Default false, connect to YouTube via the Privacy-Enhanced Mode using https://www.youtube-nocookie.com
    />
  );

  return (
    <div
      onClick={() => {
        setShowModal(true);
      }}
      className="cell-grow flex flex-column ba br2 items-start pa2 pa3-ns black-80 bg-white db shadow-0 pointer ba--primary--hover b--black-10"
      style={{ backgroundColor: COLORS.ctaBlue, maxWidth: 420 }}
    >
      <div className="w-100 flex flex-row w-100 items-center">
        <div className="w-100 flex flex-column w-100 pr2">
          <div className="flex flex-row justify-between items-center">
            <div className="f5 fw6">{header}</div>
            <div className="db dn-ns">
              <PlayIcon size={24} color={COLORS.blue} />
            </div>
          </div>
          <div className="w-100 flex flex-row items-center justify-between items-center">
            <div className="f6 lh-copy pt0 pt1-ns pr0 pr3-ns">{body}</div>
          </div>
        </div>
        <div className="dn dib-ns">
          <PlayIcon size={44} color={COLORS.blue} />
        </div>
      </div>
      {presentation === PRESENTATION.INLINE && (
        <div className="pt2">{videoPreview}</div>
      )}
      <style jsx>{cellGrow}</style>
      <style global jsx>
        {styles}
      </style>
      {presentation === PRESENTATION.MODAL && (
        <Modal
          showModal={showModal}
          onClose={() => setShowModal(false)}
          customClasses={{
            container:
              "bg-white bn ba-ns br2-ns b--black-05 shadow-0 flex flex-column center w-100 h-100 h-auto-ns mw8 outline-1"
          }}
        >
          <ModalContent>
            {() => (
              <div className="w-100 pa3">
                <div className="w-100 flex flex-column items-center">
                  {videoPreview}
                </div>
              </div>
            )}
          </ModalContent>
        </Modal>
      )}
    </div>
  );
};

export default VideoPreview;
